// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p2p-container {
  padding: 20px 0;
  width: 100%;
  max-width: none;
  margin: 0;
}
.p2p-container h1 {
  color: #2C7EA0;
  margin-bottom: 1rem;
  font-weight: 600;
}
.p2p-container p {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 2rem;
}
.p2p-container .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}
.p2p-container .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem;
}
.p2p-container .card .card-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
  font-size: 1.1rem;
}
.p2p-container .card .card-body {
  padding: 1.5rem;
}
.p2p-container .form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
.p2p-container .form-label strong {
  color: #2C7EA0;
}
.p2p-container .form-control {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.p2p-container .form-control:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.p2p-container .form-control[readonly] {
  background-color: #f8f9fa;
  color: #6c757d;
}
.p2p-container .form-select {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.p2p-container .form-select:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.p2p-container .form-check {
  margin-bottom: 0.5rem;
}
.p2p-container .form-check .form-check-input:checked {
  background-color: #2C7EA0;
  border-color: #2C7EA0;
}
.p2p-container .form-check .form-check-input:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.p2p-container .form-check .form-check-label {
  font-size: 0.9rem;
  color: #495057;
  cursor: pointer;
}
.p2p-container .btn {
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
  font-size: 0.9rem;
}
.p2p-container .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.p2p-container .btn.btn-primary {
  background-color: #2C7EA0;
  border-color: #2C7EA0;
}
.p2p-container .btn.btn-primary:hover:not(:disabled) {
  background-color: #1e5a7a;
  border-color: #1e5a7a;
  transform: translateY(-1px);
}
.p2p-container .btn.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}
.p2p-container .btn.btn-success:hover:not(:disabled) {
  background-color: #218838;
  border-color: #218838;
  transform: translateY(-1px);
}
.p2p-container .btn.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}
.p2p-container .btn.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
  transform: translateY(-1px);
}
.p2p-container .btn.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}
.p2p-container .btn.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
  border-color: #5a6268;
  transform: translateY(-1px);
}
.p2p-container .btn.btn-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.p2p-container .btn.btn-info:hover:not(:disabled) {
  background-color: #138496;
  border-color: #138496;
  transform: translateY(-1px);
}
.p2p-container .alert {
  border-radius: 6px;
  border: none;
  padding: 1rem 1.25rem;
}
.p2p-container .alert.alert-success {
  background-color: #d4edda;
  color: #155724;
}
.p2p-container .alert.alert-error {
  background-color: #f8d7da;
  color: #721c24;
}
.p2p-container .alert.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
}
.p2p-container .d-grid {
  gap: 0.75rem;
}
.p2p-container .d-md-flex {
  gap: 0.75rem;
}
.p2p-container .table {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.p2p-container .table thead {
  background-color: #f8f9fa;
}
.p2p-container .table thead th {
  border-bottom: 2px solid #dee2e6;
  color: #495057;
  font-weight: 600;
  padding: 1rem 0.75rem;
  font-size: 0.9rem;
}
.p2p-container .table tbody tr:hover {
  background-color: #f8f9fa;
}
.p2p-container .table tbody tr td {
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  font-size: 0.9rem;
  vertical-align: middle;
}
@media (max-width: 768px) {
  .p2p-container {
    padding: 15px;
  }
  .p2p-container .card-body {
    padding: 1rem;
  }
  .p2p-container .btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }
  .p2p-container .form-control,
  .p2p-container .form-select {
    padding: 0.6rem;
    font-size: 0.85rem;
  }
  .p2p-container .table {
    font-size: 0.8rem;
  }
  .p2p-container .table th, .p2p-container .table td {
    padding: 0.5rem 0.25rem;
  }
}
.p2p-container .loading {
  opacity: 0.7;
  pointer-events: none;
}
.p2p-container .generated-link {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.8rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.5rem;
  word-break: break-all;
}
.p2p-container .status-message {
  font-weight: 500;
  margin-bottom: 0;
}
.p2p-container h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}
.p2p-container .main-content-flex {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.p2p-container .sidebar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;
}
.p2p-container .sidebar.left {
  width: 260px;
  min-width: 260px;
  max-height: 80vh;
  overflow-y: auto;
}
.p2p-container .sidebar.left.closed {
  width: 50px;
  min-width: 50px;
  padding: 10px;
}
.p2p-container .sidebar .toggle-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  padding: 4px 8px;
  font-size: 12px;
}
.p2p-container .sidebar h4 {
  color: #2C7EA0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
}
.p2p-container .sidebar h4:first-child {
  margin-top: 0;
}
.p2p-container .sidebar .form-group {
  margin-bottom: 1rem;
}
.p2p-container .sidebar .form-label {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
}
.p2p-container .sidebar .form-label strong {
  color: #2C7EA0;
}
.p2p-container .sidebar .form-control,
.p2p-container .sidebar .form-select {
  font-size: 0.85rem;
  padding: 0.5rem;
  border-radius: 4px;
}
.p2p-container .sidebar .form-check {
  margin-bottom: 0.5rem;
}
.p2p-container .sidebar .form-check .form-check-label {
  font-size: 0.85rem;
  color: #495057;
}
.p2p-container .sidebar .btn {
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
}
.p2p-container .center-content {
  flex: 1;
  min-width: 0;
  width: 100%;
}
.p2p-container .center-content h4 {
  color: #2C7EA0;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}
.p2p-container .center-content .card {
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  .p2p-container .main-content-flex {
    flex-direction: column;
    gap: 15px;
  }
  .p2p-container .sidebar.left {
    width: 100%;
    min-width: auto;
    max-height: none;
  }
  .p2p-container .sidebar.left.closed {
    width: 100%;
    min-width: auto;
  }
  .p2p-container .center-content {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./frontend/sass/pages/p2p.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AACF;AACE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qBAAA;AADJ;AAGI;EACE,yBAAA;EACA,gCAAA;EACA,qBAAA;AADN;AAGM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAKI;EACE,eAAA;AAHN;AAOE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AALJ;AAOI;EACE,cAAA;AALN;AASE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wEAAA;AAPJ;AASI;EACE,qBAAA;EACA,iDAAA;AAPN;AAUI;EACE,yBAAA;EACA,cAAA;AARN;AAYE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wEAAA;AAVJ;AAYI;EACE,qBAAA;EACA,iDAAA;AAVN;AAcE;EACE,qBAAA;AAZJ;AAeM;EACE,yBAAA;EACA,qBAAA;AAbR;AAgBM;EACE,qBAAA;EACA,iDAAA;AAdR;AAkBI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAhBN;AAoBE;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;AAlBJ;AAoBI;EACE,YAAA;EACA,mBAAA;AAlBN;AAqBI;EACE,yBAAA;EACA,qBAAA;AAnBN;AAqBM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AAnBR;AAuBI;EACE,yBAAA;EACA,qBAAA;AArBN;AAuBM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AArBR;AAyBI;EACE,yBAAA;EACA,qBAAA;AAvBN;AAyBM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AAvBR;AA2BI;EACE,yBAAA;EACA,qBAAA;AAzBN;AA2BM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AAzBR;AA6BI;EACE,yBAAA;EACA,qBAAA;AA3BN;AA6BM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AA3BR;AAgCE;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;AA9BJ;AAgCI;EACE,yBAAA;EACA,cAAA;AA9BN;AAiCI;EACE,yBAAA;EACA,cAAA;AA/BN;AAkCI;EACE,yBAAA;EACA,cAAA;AAhCN;AAoCE;EACE,YAAA;AAlCJ;AAqCE;EACE,YAAA;AAnCJ;AAuCE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AArCJ;AAuCI;EACE,yBAAA;AArCN;AAuCM;EACE,gCAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AArCR;AA2CQ;EACE,yBAAA;AAzCV;AA4CQ;EACE,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,sBAAA;AA1CV;AAiDE;EA9OF;IA+OI,aAAA;EA9CF;EAgDE;IACE,aAAA;EA9CJ;EAiDE;IACE,sBAAA;IACA,kBAAA;EA/CJ;EAkDE;;IAEE,eAAA;IACA,kBAAA;EAhDJ;EAmDE;IACE,iBAAA;EAjDJ;EAmDI;IACE,uBAAA;EAjDN;AACF;AAsDE;EACE,YAAA;EACA,oBAAA;AApDJ;AAwDE;EACE,wDAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAtDJ;AA0DE;EACE,gBAAA;EACA,gBAAA;AAxDJ;AA4DE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AA1DJ;AA8DE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AA5DJ;AA+DE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AA7DJ;AA+DI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA7DN;AA+DM;EACE,WAAA;EACA,eAAA;EACA,aAAA;AA7DR;AAiEI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AA/DN;AAkEI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAhEN;AAkEM;EACE,aAAA;AAhER;AAoEI;EACE,mBAAA;AAlEN;AAqEI;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAnEN;AAqEM;EACE,cAAA;AAnER;AAuEI;;EAEE,kBAAA;EACA,eAAA;EACA,kBAAA;AArEN;AAwEI;EACE,qBAAA;AAtEN;AAwEM;EACE,kBAAA;EACA,cAAA;AAtER;AA0EI;EACE,kBAAA;EACA,oBAAA;AAxEN;AA4EE;EACE,OAAA;EACA,YAAA;EACA,WAAA;AA1EJ;AA4EI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AA1EN;AA6EI;EACE,qBAAA;AA3EN;AAgFE;EACE;IACE,sBAAA;IACA,SAAA;EA9EJ;EAiFE;IACE,WAAA;IACA,eAAA;IACA,gBAAA;EA/EJ;EAiFI;IACE,WAAA;IACA,eAAA;EA/EN;EAmFE;IACE,WAAA;EAjFJ;AACF","sourcesContent":[".p2p-container {\n  padding: 20px 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  h1 {\n    color: #2C7EA0;\n    margin-bottom: 1rem;\n    font-weight: 600;\n  }\n\n  p {\n    color: #6c757d;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n\n  .card {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    margin-bottom: 1.5rem;\n\n    .card-header {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #dee2e6;\n      padding: 1rem 1.25rem;\n\n      h5 {\n        margin: 0;\n        color: #495057;\n        font-weight: 600;\n        font-size: 1.1rem;\n      }\n    }\n\n    .card-body {\n      padding: 1.5rem;\n    }\n  }\n\n  .form-label {\n    font-weight: 500;\n    color: #495057;\n    margin-bottom: 0.5rem;\n\n    strong {\n      color: #2C7EA0;\n    }\n  }\n\n  .form-control {\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:focus {\n      border-color: #2C7EA0;\n      box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n    }\n\n    &[readonly] {\n      background-color: #f8f9fa;\n      color: #6c757d;\n    }\n  }\n\n  .form-select {\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:focus {\n      border-color: #2C7EA0;\n      box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n    }\n  }\n\n  .form-check {\n    margin-bottom: 0.5rem;\n\n    .form-check-input {\n      &:checked {\n        background-color: #2C7EA0;\n        border-color: #2C7EA0;\n      }\n\n      &:focus {\n        border-color: #2C7EA0;\n        box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n      }\n    }\n\n    .form-check-label {\n      font-size: 0.9rem;\n      color: #495057;\n      cursor: pointer;\n    }\n  }\n\n  .btn {\n    font-weight: 500;\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    transition: all 0.2s ease-in-out;\n    font-size: 0.9rem;\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &.btn-primary {\n      background-color: #2C7EA0;\n      border-color: #2C7EA0;\n\n      &:hover:not(:disabled) {\n        background-color: #1e5a7a;\n        border-color: #1e5a7a;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-success {\n      background-color: #28a745;\n      border-color: #28a745;\n\n      &:hover:not(:disabled) {\n        background-color: #218838;\n        border-color: #218838;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-danger {\n      background-color: #dc3545;\n      border-color: #dc3545;\n\n      &:hover:not(:disabled) {\n        background-color: #c82333;\n        border-color: #c82333;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-secondary {\n      background-color: #6c757d;\n      border-color: #6c757d;\n\n      &:hover:not(:disabled) {\n        background-color: #5a6268;\n        border-color: #5a6268;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-info {\n      background-color: #17a2b8;\n      border-color: #17a2b8;\n\n      &:hover:not(:disabled) {\n        background-color: #138496;\n        border-color: #138496;\n        transform: translateY(-1px);\n      }\n    }\n  }\n\n  .alert {\n    border-radius: 6px;\n    border: none;\n    padding: 1rem 1.25rem;\n\n    &.alert-success {\n      background-color: #d4edda;\n      color: #155724;\n    }\n\n    &.alert-error {\n      background-color: #f8d7da;\n      color: #721c24;\n    }\n\n    &.alert-info {\n      background-color: #d1ecf1;\n      color: #0c5460;\n    }\n  }\n\n  .d-grid {\n    gap: 0.75rem;\n  }\n\n  .d-md-flex {\n    gap: 0.75rem;\n  }\n\n  // Table styling\n  .table {\n    background-color: #fff;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n    thead {\n      background-color: #f8f9fa;\n      \n      th {\n        border-bottom: 2px solid #dee2e6;\n        color: #495057;\n        font-weight: 600;\n        padding: 1rem 0.75rem;\n        font-size: 0.9rem;\n      }\n    }\n\n    tbody {\n      tr {\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        td {\n          padding: 0.75rem;\n          border-top: 1px solid #dee2e6;\n          font-size: 0.9rem;\n          vertical-align: middle;\n        }\n      }\n    }\n  }\n\n  // Responsive adjustments\n  @media (max-width: 768px) {\n    padding: 15px;\n\n    .card-body {\n      padding: 1rem;\n    }\n\n    .btn {\n      padding: 0.6rem 1.2rem;\n      font-size: 0.85rem;\n    }\n\n    .form-control,\n    .form-select {\n      padding: 0.6rem;\n      font-size: 0.85rem;\n    }\n\n    .table {\n      font-size: 0.8rem;\n      \n      th, td {\n        padding: 0.5rem 0.25rem;\n      }\n    }\n  }\n\n  // Loading states\n  .loading {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  // Generated link styling\n  .generated-link {\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 0.8rem;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    padding: 0.5rem;\n    word-break: break-all;\n  }\n\n  // Status message styling\n  .status-message {\n    font-weight: 500;\n    margin-bottom: 0;\n  }\n\n  // Section headers\n  h6 {\n    color: #495057;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid #e9ecef;\n  }\n\n  // Sidebar styles (identical to iConsult)\n  .main-content-flex {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .sidebar {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    transition: all 0.3s ease;\n\n    &.left {\n      width: 260px;\n      min-width: 260px;\n      max-height: 80vh;\n      overflow-y: auto;\n\n      &.closed {\n        width: 50px;\n        min-width: 50px;\n        padding: 10px;\n      }\n    }\n\n    .toggle-btn {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      z-index: 10;\n      padding: 4px 8px;\n      font-size: 12px;\n    }\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin-bottom: 1rem;\n      margin-top: 1.5rem;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    .form-group {\n      margin-bottom: 1rem;\n    }\n\n    .form-label {\n      font-size: 0.9rem;\n      font-weight: 500;\n      margin-bottom: 0.5rem;\n      color: #495057;\n\n      strong {\n        color: #2C7EA0;\n      }\n    }\n\n    .form-control,\n    .form-select {\n      font-size: 0.85rem;\n      padding: 0.5rem;\n      border-radius: 4px;\n    }\n\n    .form-check {\n      margin-bottom: 0.5rem;\n\n      .form-check-label {\n        font-size: 0.85rem;\n        color: #495057;\n      }\n    }\n\n    .btn {\n      font-size: 0.85rem;\n      padding: 0.5rem 1rem;\n    }\n  }\n\n  .center-content {\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.2rem;\n      font-weight: 600;\n      margin-bottom: 1.5rem;\n    }\n\n    .card {\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  // Responsive adjustments for sidebar\n  @media (max-width: 768px) {\n    .main-content-flex {\n      flex-direction: column;\n      gap: 15px;\n    }\n\n    .sidebar.left {\n      width: 100%;\n      min-width: auto;\n      max-height: none;\n\n      &.closed {\n        width: 100%;\n        min-width: auto;\n      }\n    }\n\n    .center-content {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
